export default __webpack_public_path__ + "static/media/icon-link-accent.7f902c91.svg";